import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "main-row",
  class: "row align-items-center text-center ps-0"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppLoading',
  props: {
    loading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "col" }, [
          _createElementVNode("span", {
            class: "spinner-border spinner-border text-primary",
            role: "status",
            "aria-hidden": "true"
          })
        ], -1)
      ])))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}
}

})